<script>
  import { apiFetch } from "../../lib/api.js";
    import { user } from "../../stores/user";
    import { onMount } from "svelte";
    import { BASE_URL } from "../../stores/BASE_URL";
    import Spinner from "../Spinner.svelte";

    export let id_usuario = 0;
    let isLoading = false;
    let usuario_contratos = [];

    const getAcciones = async () => {
        isLoading = true;
        const response = await apiFetch(`${BASE_URL}usuario.php?action=getAcciones&id=${id_usuario}`);
        const resp = await response.json();
        usuario_contratos = resp.data;
        isLoading = false;
    };

    onMount(() => {
        if (!$user) {
            navigate("/", { replace: true });
        }

        getAcciones();
    });
</script>

<div class="table-responsive">
    <table class="table table-sm table-striped table-bordered small">
        <thead>
            <tr class="text-secondary fw-normal">
                <th>Acción</th>
                <th>IP</th>
                <th>Fecha</th>
            </tr>
        </thead>
        <tbody>
            {#if !isLoading}
                {#each usuario_contratos as accion}
                    <tr>
                        <td>{accion.accion}</td>
                        <td>{accion.ip}</td>
                        <td>{accion.fecha}</td>
                    </tr>
                {:else}
                    <tr>
                        <td colspan="3" class="text-center text-secondary"> · · · No se encontraron resultados · · · </td>
                    </tr>
                {/each}
            {:else}
                <td colspan="3">
                    <Spinner message="Cargando" />
                </td>
            {/if}
        </tbody>
    </table>
</div>
